import AssignmentForm from "../../admin/assignments/AssignmentForm";
import { Alert, Empty, Spin } from "antd"
import { useDispatch } from "react-redux"
import { useGetQuizzesQuery } from "../../../features/quizzes/quizzesApi";
import QuizzesTable from "../../admin/quizzes/QuizzesTable";
import { toggleModal, editQuiz } from "../../../features/quizzes/quizzesSlice"
import QuizForm from "../../admin/quizzes/QuizForm";

export default function Quizzes() {
  const dispatch = useDispatch()

  const { data: quizzes, isLoading, isError, error } = useGetQuizzesQuery()

  // decide what to render 
  let render = null;
  if (isLoading) {
    render = <Spin />
  } else if (isError && error) {
    render = <Alert message="Error" description={typeof error?.data == 'string' ? error?.data : 'Something went wrong'}
      type="error"
      showIcon
    />
  } else if (!quizzes?.length) {
    render = <Empty description="No Data Found" />
  } else {
    render = <QuizzesTable quizzes={quizzes} />
  }

  const openModalHandler = () => {
    dispatch(editQuiz({}))
    dispatch(toggleModal(true))
  }
  return (
    <>
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <div className="px-3 py-20 bg-opacity-10">
            <div className="w-full flex">
              <button className="btn cursor-pointer ml-auto" onClick={openModalHandler}>Add Quiz</button>
            </div>
            <div className="overflow-x-auto mt-4">
              {render}
            </div>
          </div>
        </div>
      </section>

      <QuizForm />
    </>
  )
}